import { spanFromRegExpMatch } from '../spans';
import type { ExtractorOutput } from './types';

/**
 * "with photos/images" → hasImage true; "without photos" / "no images" → false.
 */
export function extractHasImage(query: string): ExtractorOutput {
  const hideWithout =
    /\b(?:hide\s+listings\s+without\s+(?:images?|photos?|pictures?)|only\s+(?:with\s+)?(?:images?|photos?|pictures?))\b/gi;
  const hideMatch = hideWithout.exec(query);
  if (hideMatch) {
    return {
      partial: { hasImage: true },
      spans: [
        spanFromRegExpMatch(query, hideMatch, 'hasImage', true, {
          confidence: 0.9,
          ruleId: 'hasImage.hide-without',
        }),
      ],
    };
  }

  const without = /\b(?:without|no|w\/o)\s+(?:images?|photos?|pictures?)\b/gi;
  const withoutMatch = without.exec(query);
  if (withoutMatch) {
    return {
      partial: { hasImage: false },
      spans: [
        spanFromRegExpMatch(query, withoutMatch, 'hasImage', false, {
          confidence: 0.9,
          ruleId: 'hasImage.false',
        }),
      ],
    };
  }

  const withImages = /\b(?:with|has|have)\s+(?:images?|photos?|pictures?)\b/gi;
  const withMatch = withImages.exec(query);
  if (withMatch) {
    return {
      partial: { hasImage: true },
      spans: [
        spanFromRegExpMatch(query, withMatch, 'hasImage', true, {
          confidence: 0.85,
          ruleId: 'hasImage.true',
        }),
      ],
    };
  }

  return { partial: {}, spans: [] };
}

/**
 * Coming Soon listings toggle.
 */
export function extractShowComingSoon(query: string): ExtractorOutput {
  const exclude =
    /\b(?:no|without|exclude|hide|don't\s+show|do\s+not\s+show)\s+coming\s+soon(?:\s+listings?)?\b/gi;
  const excludeMatch = exclude.exec(query);
  if (excludeMatch) {
    return {
      partial: { showComingSoon: false },
      spans: [
        spanFromRegExpMatch(query, excludeMatch, 'showComingSoon', false, {
          confidence: 0.9,
          ruleId: 'showComingSoon.false',
        }),
      ],
    };
  }

  const include = /\bcoming\s+soon(?:\s+listings?)?\b/gi;
  const includeMatch = include.exec(query);
  if (includeMatch) {
    return {
      partial: { showComingSoon: true },
      spans: [
        spanFromRegExpMatch(query, includeMatch, 'showComingSoon', true, {
          confidence: 0.95,
          ruleId: 'showComingSoon.true',
        }),
      ],
    };
  }

  return { partial: {}, spans: [] };
}
